import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ConsultationForm.css"; // custom styling

export default function ConsultationForm() {
  return (
    <div className="consultation-container d-flex align-items-center">
      <div className="form-section col-lg-6 col-md-12">
        <h2 className="form-title">
          In Search of Care? <br />
          <span className="highlight">Request a Consultation Today</span>
        </h2>
        <p className="form-subtitle">
          Please fill out the form below to explore your options for care and
          get your questions answered:
        </p>
        <form className="consultation-form">
          <div className="row">
            <div className="col-md-6 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="First Name*"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Last Name*"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Email Address*"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <input
                type="tel"
                className="form-control"
                placeholder="Phone Number"
              />
            </div>
            <div className="col-md-6 mb-3">
              <select className="form-control">
                <option>How did you discover us?</option>
                <option>Google</option>
                <option>Facebook</option>
                <option>Referral</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <select className="form-control">
                <option>New or Existing Patient?</option>
                <option>New Patient</option>
                <option>Existing Patient</option>
              </select>
            </div>
            <div className="col-12 mb-3">
              <textarea
                className="form-control"
                rows="3"
                placeholder="Add a Message"
              ></textarea>
            </div>
          </div>
          <button type="submit" className="btn submit-btn">
            Submit →
          </button>
        </form>
        <div className="hipaa">HIPAA COMPLIANCE</div>
      </div>
      <div className="image-section col-lg-6 d-none d-lg-block">
        {/* <img src={first} alt="Doctor" className="img-fluid doctor-img" /> */}
      </div>
    </div>
  );
}
